export default "__VITE_ASSET__1bf1794c__"